import React from "react";
import { ReportField } from "./ReportField";
import { Box } from "@mui/material";

interface AdditionalNotesContainerProps {
  userId: string;
  propertyId: string;
}

export const AdditionalNotesContainer: React.FC<
  AdditionalNotesContainerProps
> = ({ userId, propertyId }) => {
  return (
    <Box sx={{ pl: 6 }}>
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Potential Buyer Concerns"
        fieldKey="additionalNotes.potentialBuyerConcerns"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Unique Selling Points"
        fieldKey="additionalNotes.uniqueSellingPoints"
      />
    </Box>
  );
};
